import { Component, Input } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { FieldType, DisplayableInfo } from 'ng2-app/modules/borrower/models/application-requirements/application-requirements.interface';

export interface DisplayableField {
    alias: string;
    type: FieldType;
    name: string;
    editable: boolean;
}

@Component({
    selector: 'borrower-attribute',
    templateUrl: 'borrower-attribute.component.html',
    standalone: false
})
export class BorrowerAttributeComponent {

    @Input() form: UntypedFormGroup;
    @Input() field: DisplayableField;
    @Input() disabled: any;
    @Input() displayableInfo: DisplayableInfo | undefined;

}
